'use client';

import React, { useState } from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { LoadingBall } from '@depop/web-ui-kit/LoadingBall';
import clsx from 'clsx';

import { AppleSignupButton } from '../AppleSignupButton';
import { GoogleSignupButton } from '../GoogleSignupButton';

import styles from './styles.module.css';

import { SSOButtonVariant } from '@/modules/auth/types';

type Props = { ssoButtonVariant: SSOButtonVariant; nonce: string };

function SocialSignUp({ ssoButtonVariant, nonce }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [errorText, setError] = useState('');

  const isEyeCatchingVariant =
    ssoButtonVariant === SSOButtonVariant.EyeCatching;

  return (
    <>
      {errorText && (
        <Caption variant="lg-regular" className={styles.errorText}>
          {errorText}
        </Caption>
      )}
      {isLoading && <LoadingBall className={styles.loader} />}
      <div
        className={clsx(
          isEyeCatchingVariant ? styles.rowWrapper : styles.columnWrapper
        )}
      >
        <GoogleSignupButton
          setError={setError}
          setIsLoading={setIsLoading}
          ssoButtonVariant={ssoButtonVariant}
          nonce={nonce}
        />
        <AppleSignupButton
          setError={setError}
          setIsLoading={setIsLoading}
          ssoButtonVariant={ssoButtonVariant}
        />
      </div>
    </>
  );
}

export { SocialSignUp };
